import ApiService, { HTTPMethod } from './api.core'

export class DeclinationApi{

  static async manageDeclinations(body){
    let res = await ApiService.fetch("declinations/manage-declinations", HTTPMethod.POST,body);
    return res; 
  }
}

